export const groupType = {
  myContacts: 'my contacts',
  relativeContacts: 'relative contacts',
  education: 'education',
  experience: 'experience',
}
